module.exports = __webpack_public_path__ + "static/media/quality.7954665b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/quality.svg
// module id = 606
// module chunks = 0